<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  viewBox="0 0 512 512"
>
  <path
    d="M442.947 294.957c-10.17-68.812-56.721-125.591-120.164-149.374V33.391h16.327c9.22 0 16.696-7.475 16.696-16.696S348.33 0 339.11 0H172.153c-9.22 0-16.696 7.475-16.696 16.696s7.475 16.696 16.696 16.696h17.064v112.464C125.774 169.8 79.184 226.412 69.053 294.957c-1.346 9.106-2.271 18.346-2.271 27.826C66.783 427.284 151.497 512 256 512s189.217-84.716 189.217-189.217c0-9.48-.925-18.721-2.27-27.826z"
    fill="#e0e0e2"
  />
  <path
    d="M442.947 294.957c-10.17-68.812-56.721-125.591-120.164-149.374V33.391h16.327c9.22 0 16.696-7.475 16.696-16.696S348.33 0 339.11 0H256v512c104.501 0 189.217-84.716 189.217-189.217 0-9.48-.925-18.721-2.27-27.826z"
    fill="#c6c5ca"
  />
  <path
    d="M69.053 294.957c-1.346 9.106-2.271 18.346-2.271 27.826C66.783 427.284 151.497 512 256 512s189.217-84.716 189.217-189.217c0-9.48-.925-18.72-2.271-27.826H69.053z"
    fill="#933ec5"
  />
  <path
    d="M256 294.957V512c104.501 0 189.217-84.716 189.217-189.217 0-9.48-.925-18.72-2.271-27.826H256z"
    fill="#6d2c93"
  />
  <circle cx="283.459" cy="395.13" r="50.087" fill="#b87fd9" />
  <circle
    cx="183.285"
    cy="361.739"
    r="16.696"
    fill="#b87fd9"
  />
  <circle cx="250.067" cy="228.174" r="16.696" fill="#6d2c93" />
</svg>
